var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m12.746 16.613 6.99 6.985-6.99 6.986-6.99-6.986zM17.818 11.532l7.03-7.025L36.53 16.475 29.5 23.5zM18.5 36l6.68 6L37 30.5l-.078-13z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoWhite;